import { render, staticRenderFns } from "./InterstitialBannerPreview.vue?vue&type=template&id=5189d3bb&scoped=true&"
import script from "./InterstitialBannerPreview.vue?vue&type=script&lang=js&"
export * from "./InterstitialBannerPreview.vue?vue&type=script&lang=js&"
import style0 from "./InterstitialBannerPreview.vue?vue&type=style&index=0&id=5189d3bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189d3bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFooter,VImg,VSpacer})
